import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfigObjectModel, SystemPreferencesService, anyGlobal } from '@thehubz/client/core';
import { CollectionsApiService } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';
import { tap } from 'rxjs';
import { CollectionInfo } from '../collection-info.model';
import { SelectCollectionPopupComponent } from '../components/select-collection-popup/select-collection-popup.component';
import { CollectionAssetPreviewService } from '../services/collection-asset-preview.service';

@Component({
  selector: 'thehubz-collection-dashboard-view',
  templateUrl: './collection-dashboard-view.component.html',
  styleUrls: ['./collection-dashboard-view.component.scss'],
})
export class CollectionDashboardViewComponent implements OnInit {
  collectionData: CollectionInfo[] = [];
  basketDataLoaded = false;
  configObject: ConfigObjectModel = {
    title: $localize`Published collection`,
    callFrom: 'dashboard',
  };
  filterObject = {
    filters: {
      assetId: '',
      search: '',
    },
    sort: { createdAt: -1 },
  };
  dialogSelectRef!: MatDialogRef<SelectCollectionPopupComponent>;
  dialogSelectState?: number;
  /**
   * True when data is loading from server
   */
  httpCallInProgress = false;

  AnyGlobal = anyGlobal;

  constructor(
    private collectionAPI: CollectionsApiService,
    private systemPreferencesService: SystemPreferencesService,
    private dialog: MatDialog,
    private collectionAssetPreviewService: CollectionAssetPreviewService,
  ) {}

  ngOnInit(): void {
    // resigning empty string because search value assigned at parent component (collection.component.ts)
    this._showLoader();
    this.getSystemPreference();
  }

  async getSystemPreference(forceCheck?: boolean) {
    const data = await this.systemPreferencesService.getUserPreferences();
    const collectionData = data.dashboardCollection || [];
    this.fetchCollections(collectionData, forceCheck);
  }
  /**
   * get all collection list of logged in user
   * @param searchText
   */
  fetchCollections(collections: string[], forceCheck?: boolean) {
    if (collections.length > 0 || forceCheck) {
      const collectionListData: AnyType = { list: collections };
      this.collectionAPI
        .collectionsControllerFindCollectionList(JSON.stringify(collectionListData))
        .pipe(tap(() => this._showLoader(false)))
        .subscribe({
          next: async (response) => {
            this.collectionData = response.result;
            if (this.collectionData.length) {
              this.collectionData = await this.collectionAssetPreviewService.generateCoverPreview(this.collectionData);
              this.basketDataLoaded = true;
            } else {
              this.basketDataLoaded = true;
            }
          },
        });
    } else {
      this._showLoader(false);
      this.basketDataLoaded = true;
    }
  }

  editInformation() {
    this.dialogSelectRef = this.dialog.open(SelectCollectionPopupComponent, {
      maxWidth: '120rem',
      width: '60%',
      height: '80%',
      data: {
        selectedCollection: this.collectionData,
      },
    });
    this.dialogSelectState = this.dialogSelectRef.getState();
    this.dialogSelectRef.disableClose = true;
    this.dialogSelectRef.afterClosed().subscribe(async (result: AnyType) => {
      this.dialogSelectState = undefined;
      if (result) {
        this.getSystemPreference(true);
      }
    });
  }

  /**
   * Utility method to show/hide loader
   */
  private _showLoader(show = true) {
    this.httpCallInProgress = show;
  }
}
